//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Fragment } from "vue-fragment";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "EmailReadOnlyArgument",
  components: {
    Fragment
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    showContentTitle: {
      type: Boolean,
      default: true
    }
  }
});